import React, { useState, useEffect } from "react";
import "./CourseSyllabus.css";
import Popupboxx from "../Popupbox/Popupbox";
import AOS from "aos";
import "aos/dist/aos.css";


  const courseModules = [
  {
    title: "Front-End Development: HTML",
    points: [
      "Introduction to HTML and its basic structure",
      "Working with tags, paragraphs, headings, and text formatting",
      "Creating lists, images, tables, and forms",
      "Embedding media elements"
    ]
  },
  {
    title: "CSS",
    points: [
      "Understanding the types of CSS and their applications",
      "Exploring CSS properties, selectors, and values",
      "Applying styles to HTML elements",
      "Implementing the box model, margins, padding, and borders",
      "Styling text and fonts",
      "Advanced topics like animations and responsive design"
    ]
  },
  {
    title: "JavaScript",
    points: [
      "Introduction to JavaScript and its syntax",
      "Variables, data types, and operators",
      "Control structures: conditional statements and loops",
      "Functions and events",
      "DOM manipulation and form validation"
    ]
  },
  {
    title: "Frameworks & Libraries",
    points: [
      "Introduction to jQuery and its features",
      "Selectors, events, and effects",
      "Working with UI components like accordions and tabs",
      "Setting up Bootstrap and understanding its grid system",
      "Utilizing components like buttons, navbars, and carousels",
      "Creating responsive layouts"
    ]
  },
  {
    title: "Back-End Development: Python",
    points: [
      "Introduction to Python and its syntax",
      "Data types, variables, and operators",
      "Control flow statements: if-else, loops",
      "Functions and modules",
      "File handling and exception management",
      "Object-Oriented Programming (OOP) concepts"
    ]
  },
  {
    title: "Django Framework",
    points: [
      "Setting up Django projects and applications",
      "Understanding the MTV (Model-Template-View) architecture",
      "Working with models, views, and templates",
      "Handling forms and validations",
      "User authentication and authorization",
      "Deploying Django applications"
    ]
  },
  {
    title: "Flask Framework",
    points: [
      "Introduction to Flask and its setup",
      "Routing and view functions",
      "Template rendering",
      "Working with forms and handling requests",
      "Database integration using SQLAlchemy"
    ]
  },
  {
    title: "Database Management",
    points: [
      "Introduction to databases and SQL",
      "Designing and managing relational databases",
      "Performing CRUD (Create, Read, Update, Delete) operations",
      "Integrating databases with Python applications",
      "Understanding Object-Relational Mapping (ORM) with Django ORM or SQLAlchemy"
    ]
  },
  {
    title: "DevOps & Core Concepts",
    points: [
      "Introduction to Git and version control systems",
      "Creating and managing repositories, branching, merging, and resolving conflicts",
      "Collaborating using platforms like GitHub or GitLab",
      "Understanding RESTful API principles",
      "Creating APIs using Django REST Framework or Flask-RESTful",
      "Consuming external APIs in applications",
      "Deploying applications on cloud platforms like AWS, Heroku, or Azure",
      "Configuring web servers and databases for production",
      "Monitoring and maintaining deployed applications"
    ]
  }
];

function CourseSyllabus() {
  const [activeModule, setActiveModule] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  // Detect screen size
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // check on load
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

   useEffect(() => {
      AOS.init({ duration: 800, once: true });
    }, []);

  return (
    <>
    <section className="syllabus-section">
      <div className="container">
        <div className="headlines-for-all">
          <h4   data-aos="fade-up">
            <span>Course </span> Syllabus
          </h4>
          <p  data-aos="fade-up">
            Explore our comprehensive Python syllabus — built for
            real-world projects, hands-on learning, and 100% job readiness.
          </p>
        </div>


        {/* ---------- Desktop Tabs ---------- */}
        {!isMobile && (
          <>
            <div className="custom-btn-group "   data-aos="fade-up">
              {courseModules.map((m, index) => (
                <button
                  key={index}
                  className={`custom-btn ${activeModule === index ? "active" : ""
                    }`}
                  onClick={() => setActiveModule(index)}
                >
                  Module {index + 1}
                </button>
              ))}
            </div>

            <div className="custom-module-container"   data-aos="fade-up">
              <div className="custom-module-box active">
                <h4>{courseModules[activeModule].title}</h4>
                <ul className="ul-list-module">
                  {courseModules[activeModule].points.map((p, i) => (
                    <li key={i}>{p}</li>
                  ))}
                </ul>
              </div>
            </div>
          </>
        )}

        {/* ---------- Mobile Accordion (FAQ Style) ---------- */}
        {isMobile && (
          <div className="faq-container-course"   data-aos="fade-up">
            {courseModules.map((m, index) => (
              <div
                key={index}
                className={`faq-item-course ${activeModule === index ? "open" : ""
                  }`}
              >
                <button
                  className="faq-question-course"
                  onClick={() =>
                    setActiveModule(activeModule === index ? null : index)
                  }
                >
                  {m.title}
                  <span className="faq-icon-course">
                    {activeModule === index ? "−" : "+"}
                  </span>
                </button>

                <div
                  className="faq-answer-course"
                  style={{
                    maxHeight: activeModule === index ? "400px" : "0px",
                  }}
                >
                  <ul>
                    {m.points.map((p, i) => (
                      <li key={i}>{p}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="btn-center"   data-aos="fade-up">
          <button className="download-btn" onClick={() => setIsPopupOpen(true)}>Download Syllabus</button>
        </div>
      </div>
    </section>

  
       <Popupboxx
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
      />
      </>
  );
}

export default CourseSyllabus;
